var map = {
	"./assets/android-qr-code.png": 8385,
	"./assets/background-image.svg": 2744,
	"./assets/backspace.svg": 6614,
	"./assets/blood-pressure-dark-green.svg": 3332,
	"./assets/blood-pressure.svg": 5897,
	"./assets/checkmark.svg": 1673,
	"./assets/coffee_photos/FWD_AJ.png": 5178,
	"./assets/coffee_photos/FWD_Cap.png": 9060,
	"./assets/coffee_photos/FWD_EarlGrey.png": 6670,
	"./assets/coffee_photos/FWD_EnglishBreakfastTea.png": 5767,
	"./assets/coffee_photos/FWD_HotBlack.png": 9922,
	"./assets/coffee_photos/FWD_IcedBlack.png": 2583,
	"./assets/coffee_photos/FWD_IcedLatte.png": 2217,
	"./assets/coffee_photos/FWD_Jasmine.png": 8363,
	"./assets/coffee_photos/FWD_Latte.png": 361,
	"./assets/coffee_photos/FWD_OJ.png": 3531,
	"./assets/colour-star.svg": 3119,
	"./assets/crossmark.svg": 2201,
	"./assets/dropdown-close.svg": 5864,
	"./assets/dummy-coffee.png": 4561,
	"./assets/email-icon-white.svg": 3901,
	"./assets/email-icon.svg": 5124,
	"./assets/face-animation": 5200,
	"./assets/face-animation.json": 5200,
	"./assets/face-id.svg": 2675,
	"./assets/fwd-icon.svg": 8155,
	"./assets/grey-star.svg": 493,
	"./assets/icon.gif": 9245,
	"./assets/ios-qr-code.png": 2825,
	"./assets/label.png": 8221,
	"./assets/left-arrow-icon.svg": 6037,
	"./assets/loading.gif": 3612,
	"./assets/panoptic_ai.svg": 7144,
	"./assets/panoptic_ai_vitals.png": 1328,
	"./assets/qr-placeholder.svg": 6460,
	"./assets/report.svg": 9086,
	"./assets/silhouette.png": 2879,
	"./assets/skin-age-dark-green.svg": 177,
	"./assets/skin-age.svg": 8818,
	"./assets/spinner.svg": 4418,
	"./assets/stress-dark-green.svg": 7911,
	"./assets/stress.svg": 4220,
	"./assets/survey-qr.png": 9206,
	"./assets/switch-camera.svg": 8540,
	"./assets/time-spinner-orange.svg": 7494,
	"./assets/time-spinner.svg": 3105,
	"./assets/wechat-icon.svg": 2053,
	"./assets/wechat-qr-code.png": 9085,
	"./assets/wellness.svg": 4383,
	"./assets/whatsapp-icon.svg": 4958,
	"./card-content": 638,
	"./card-content.vue": 638,
	"./circular-progress": 4022,
	"./circular-progress.vue": 4022,
	"./condition-checking": 7215,
	"./condition-checking.vue": 7215,
	"./condition-icon": 9553,
	"./condition-icon.vue": 9553,
	"./conditions-hud": 5846,
	"./conditions-hud.vue": 5846,
	"./home-page": 7833,
	"./home-page.vue": 7833,
	"./loading-screen": 7574,
	"./loading-screen.vue": 7574,
	"./plans": 5755,
	"./plans.js": 5755,
	"./quiz": 8204,
	"./quiz.vue": 8204,
	"./restart-modal": 7559,
	"./restart-modal.vue": 7559,
	"./result/email": 8783,
	"./result/email.vue": 8783,
	"./result/metrics-result": 436,
	"./result/metrics-result.vue": 436,
	"./result/print-guideline": 6038,
	"./result/print-guideline.vue": 6038,
	"./result/report": 1888,
	"./result/report.vue": 1888,
	"./result/result": 3300,
	"./result/result.vue": 3300,
	"./result/send-result": 1811,
	"./result/send-result.vue": 1811,
	"./result/send-status": 8419,
	"./result/send-status.vue": 8419,
	"./result/sending-method": 6152,
	"./result/sending-method.vue": 6152,
	"./result/wechat": 9975,
	"./result/wechat.vue": 9975,
	"./result/whatsapp": 6416,
	"./result/whatsapp.vue": 6416,
	"./start-content": 3111,
	"./start-content.vue": 3111,
	"./user-profile-input": 7130,
	"./user-profile-input.vue": 7130,
	"./vital-sign-button-js": 9317,
	"./vital-sign-button-js.vue": 9317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 656;